export const geocodeKey = 'AIzaSyAHkNa_EIXh3UTRwtbJxtbHxc3mL2Cp47g';
